import { useCallback } from 'react';

import { actions } from '../models';
import { useAppDispatch } from '../store';

export const useLoginInfo = () => {
  const dispatch = useAppDispatch();

  const setIsLogged = useCallback((isLogged: boolean) => dispatch(actions.user.setIsLogged(isLogged)), [dispatch]);

  const setIdpUser = useCallback(
    (sub: string) => {
      if (!sub) return;
      dispatch(actions.user.setIdpUser(sub));
    },
    [dispatch],
  );

  return { setIdpUser, setIsLogged };
};
